import React, { useContext } from 'react';
import {GlobalContext} from "../../handlers/GlobalContext";

const Loading = () => {
    const [ state, dispatch] = useContext(GlobalContext);
    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <div className={'loading-wrap fixed-top'} style={{...loadingStyle}}>
            <h5>{translate("products-info-loading","Loading...")}</h5>
        </div>
    );
};

const loadingStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: "rgba(255,255,255,0.9)"
};

export default Loading;